<template>
  <span>
    <!-- Tab -->
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Vessel Name</label>
          <div class="col-sm-9">
            <my-select
              disableFormControl="true"
              :selection.sync="form.vessel_id"
              :suggestions="vessels"
              placeholder="Select Vessel name"
            ></my-select>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Machinary Group</label>
          <div class="col-sm-9">
            <my-select
              disableFormControl="true"
              :selection.sync="form.marchinery_group"
              :suggestions="machinaryGroups"
              placeholder="Select Machinary Group"
            ></my-select>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Title</label>
          <div class="col-sm-9">
            <input
              type="text"
              v-model="form.title"
              class="form-control"
              placeholder="Title"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Parameter Type</label>
          <div class="col-sm-9">
            <my-select
              disableFormControl="true"
              :selection.sync="form.parameter_type"
              :suggestions="parameterTypes"
              placeholder="Select Parameter Types"
            ></my-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <label class="col-form-label">Machinery</label>
            <div class="col-sm-9">
              <input
                type="text"
                v-model="form.machinery"
                class="form-control"
                placeholder="Machinery"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  name: "ParameterSetupFormWidget",
  props: ["form"],
  data() {
    return {
      vessels: [],
      machinaryGroups: [],
      parameterTypes: [
        { id: "Temperature", name: "Temperature" },
        { id: "Pressure", name: "Pressure" },
      ],
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("parameter_setups/masters");
      masters = masters.data;
      masters.vessels.forEach((vessel) => {
        this.vessels.push({
          id: vessel.id,
          name: vessel.name,
        });
      });
      masters.machinery_groups.forEach((machinary_group) => {
        machinary_group.json_data.forEach((json) => {
          this.machinaryGroups.push({
            id: machinary_group.id,
            name: json.name,
          });
        });
      });
    },
  },
};
</script>
